// eslint-disable-next-line import/no-anonymous-default-export
export default [
    'Client',
    'Expert Witness',
    'Opposing Counsel',
    'Potential Client',
    'Other'
]
